import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import activeEventReducer from './slices/activeEventSlice';
import reportControlsReducer from './slices/reportControlsSlice';
import uiReducer from './slices/uiSlice';
import staffGlobalReducer from './slices/staffGlobalSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['activeEvent', 'reportControls', 'ui'],
  debug: false
};

const rootReducer = combineReducers({
  activeEvent: activeEventReducer,
  reportControls: reportControlsReducer,
  ui: uiReducer,
  staffGlobal: staffGlobalReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { dispatch, persister, useDispatch, useSelector };
